/**
 * 门店设置与功能开关接口
 * 对应 server/src/modules/settings
 */
import { http } from '@/lib/api/http';
import type { FeatureEntitlement, StoreSetting } from '@/lib/api/types';

export const settingsApi = {
  /** 某门店的全部设置项，key-value 形式（小票、支付方式、营业时间等） */
  list: (params: { storeId: string }) =>
    http.get<StoreSetting[]>('/settings', { query: params }),

  /**
   * 按 key 覆盖写入，不存在就新建。
   *
   * **`value` 必须是对象**（服务端 `@IsObject()`）。要存数组就包一层，
   * 如打印分配存成 `{ routes: [...] }`——改服务端契约会影响小票、
   * 支付方式等共用这个 DTO 的其他设置。
   */
  upsert: (input: {
    storeId: string;
    /** 设置项键名，如 receipt、payment、business_hours */
    key: string;
    value: Record<string, unknown>;
  }) => http.post<StoreSetting>('/settings', { body: input }),
};

export const featuresApi = {
  /** 功能中心的开关清单。基础模式 / 专业模式的差别就在这里 */
  list: () => http.get<FeatureEntitlement[]>('/features'),

  /**
   * 开启或关闭一项能力，商户级生效。
   *
   * **没有 storeId**：能力开关本轮只做商户级。之前这里可以传 storeId，
   * 但服务端从不用它定位记录，传了也只是全商户一起变——这种"传了不生效"的参数
   * 比没有更容易让人以为已经能按门店配。门店级差异化要先定口径再开。
   */
  upsert: (input: {
    /** 功能码，如 appointments、inventory、payroll、marketing */
    featureCode: string;
    enabled: boolean;
    limits?: Record<string, unknown>;
  }) => http.post<FeatureEntitlement>('/features', { body: input }),
};
